import { Cmp } from '@hmg/consent-and-tracking';

export default function initCMP() {

  var currentConfig;

  if (window.location.toString().includes('abo.handelsblatt.com')) {
    currentConfig = {
      managerId: 1073878,
      privacyManagerId: 1073878,
      accountId: 692,
      propertyHref: 'https://nonliveabo.handelsblatt.com',
      librarySrc: 'https://cdn.privacy-mgmt.com/unified/wrapperMessagingWithoutDetection.js',
      baseEndpoint: 'https://cdn.privacy-mgmt.com',
      propertyId: 35117,
      gdpr: { },
      joinHref: true,
    };
  } else {
    currentConfig = {
      managerId: 350659,
      privacyManagerId: 350659,
      accountId: 692,
      librarySrc: 'https://cdn.privacy-mgmt.com/unified/wrapperMessagingWithoutDetection.js',
      baseEndpoint: 'https://cdn.privacy-mgmt.com',
      gdpr: { },
      // propertyHref: 'https://nonliveabo.wiwo.com',
      // propertyId: 35117,
    };
  }
  const isSpa = window.__is_iframe === true ?? false; 

  // vorher
  // baseEndpoint = 'https://cdn.privacy-mgmt.com';
  // librarySrc = 'https://cdn.privacy-mgmt.com/wrapperMessagingWithoutDetection.js';

  // mandatory settings from your Sourcepoint account
  /**
   * @type CmpSettings
   */
  var cmpSettings = {
    sourcepoint: {
      ...currentConfig,
      events: {
        onConsentReadyWrapper: function (_this) {
          // _this context is based on 
          // @hmg/consent-and-tracking/es2015/consent/cmp/sourcepoint/sourcepoint.js
          _this.consentReadyDeffered.resolve();
          _this.onConsentReady();
        },
        onError: function (messageType, errorCode, errorObject, userReset) {
          console.error(messageType, errorCode, errorObject, userReset);
        },
      },
    },
    gtm: {
      vendorId: '5e952f6107d9d20c88e7c975',
      containerName: window.GTM_ID,
    },
    onPageload: (listener) => {
      console.log('on page load cmp, spa', isSpa);
      if (isSpa) {
        checkIframeCookie(listener);
      }
    },
  };

  
  if (window.GTM_ENV && window.GTM_AUTH) {
    cmpSettings.gtm.environment = window.GTM_ENV;
    cmpSettings.gtm.auth = window.GTM_AUTH;
  }

  // console.log('CMP settings', cmpSettings);
  return new Cmp(cmpSettings);
}

function getCookie(name) {
  // Split cookie string and get all individual name=value pairs in an array
  const cookieArr = document.cookie.split(';');

  // Loop through the array elements
  for (let i = 0; i < cookieArr.length; i++) {
    let cookiePair = cookieArr[i].split('=');

    /* Removing whitespace at the beginning of the cookie name
    and compare it with the given string */
    if (name === cookiePair[0].trim()) {
      // Decode the cookie value and return
      return decodeURIComponent(cookiePair[1]);
    }
  }

  // Return null if not found
  return null;
}
function checkIframeCookie(callback) {
  const consent = getCookie('consentUUID');
  const hasConsent = consent != null; // && consent.substr(0, 3) === "1!1";
  console.log('PAGE IN IFRAME - checked CMP Consent: ', hasConsent);
  // if consent exists, we'll just load cmp!, if not - not!
  try {
    if (hasConsent) {
      callback();
    }
  } catch (e) {
    console.error(e);
  }
}
